import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.keys.js";
var Encode = encodeURIComponent;
var Decode = decodeURIComponent;
var Doc = document;
var Cookie = /*#__PURE__*/function () {
  function Cookie() {
    _classCallCheck(this, Cookie);
    this.data = {};
    // this._parse()
  }

  _createClass(Cookie, [{
    key: "_parse",
    value: function _parse() {
      var cookies = Doc.cookie.split(/; ?/g) || [];
      this.data = {};
      try {
        for (var i = 0; i < cookies.length; i++) {
          var item = (cookies[i] || '').trim();
          if (!item) continue;
          var _item$split = item.split('='),
            _item$split2 = _slicedToArray(_item$split, 2),
            key = _item$split2[0],
            value = _item$split2[1];
          if (!this.data[key]) {
            value = /^[[{]]/.test(value) ? JSON.parse(value) : value;
            this.data[key] = Decode(value);
          }
        }
      } catch (error) {
        console.log(error);
      }
      return this.data;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return !Object.keys(this.data).length ? this._parse() : this.data;
    }
  }, {
    key: "get",
    value: function get(name) {
      return this.getForce(name);
    }
  }, {
    key: "getForce",
    value: function getForce(name) {
      // 强制获取 （重新读取数据）
      return this._parse()[name];
    }
  }, {
    key: "set",
    value: function set(name, value) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/',
        expires: '',
        domain: ''
      };
      if (!name || typeof name !== 'string') throw new Error(' Cookie key name must be a string ');
      var cookieStr = '';
      if (opts.expires && typeof opts.expires === 'number') {
        opts.expires = new Date(new Date() * 1 + opts.expires * 864e+5).toUTCString();
      }
      try {
        var str = JSON.stringify(value);
        if (/^[{[]/.test(str)) value = str;
      } catch (error) {}
      cookieStr = name + '=' + Encode(value);
      for (var key in opts) {
        var _value = opts[key];
        if (!_value) continue;
        cookieStr += '; ' + key;
        if (_value === true) continue;
        cookieStr += '=' + _value;
      }
      document.cookie = cookieStr;
    }
  }, {
    key: "has",
    value: function has(name) {
      return !!this.data[name];
    }
  }]);
  return Cookie;
}();
export default new Cookie();